import React from "react";
import { useTranslation } from "react-i18next";
import testiLeftLTR from "../../assets/images/all-img/Testimonial-03.webp";
import testiLeftRTL from "../../assets/images/all-img/Testimonial-06.webp"; // 👈 add your RTL image here

const Testimonials = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <div
      className="section-padding bg-[url('../images/all-img/section-bg-16.png')] bg-cover bg-no-repeat"
      style={{ marginTop: "120px", marginBottom: "120px" }}
    >
      <div className="container">
        <div className="grid grid-cols-12 lg:gap-10 gap-6">
          <div className="xl:col-span-6 lg:col-span-6 col-span-12">
            <img
              src={isRTL ? testiLeftRTL : testiLeftLTR}
              alt="Testimonials"
              draggable="false"
              className={`${isRTL ? "pl-4 ml-2" : "pr-4 mr-2"} rounded-lg `}
            />
          </div>
          <div className="xl:col-span-6 lg:col-span-6 col-span-12 flex flex-col justify-center">
            <div className="mini-title">{t("testimonials.mini_title")}</div>
            <h4 className="column-title">{t("testimonials.title")}</h4>
            <div className="space-y-6 mt-4">
              {t("testimonials.reviews", { returnObjects: true }).map(
                (review, index) => (
                  <div
                    key={index}
                    className={`${
                      isRTL ? "border-r-4 pr-4" : "border-l-4 pl-4"
                    } border-primary`}
                  >
                    <p className="italic">"{review.quote}"</p>
                    <p className="font-bold">
                      {review.name},{" "}
                      <span className="text-gray-600">{review.position}</span>
                    </p>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
